export const hasPathFinderData = (pathfinderDataState) => {
  return !(Object.keys(pathfinderDataState).length === 0);
};

export const updateStylesAndContent = ({
  pathFinderMeshComponent,
  pathfinderDataState,
  game,
  prevPathFinderData,
}) => {
  const stepIndex = game?.paths?.paths?.findIndex(
    (step) => step.id === pathfinderDataState.currentPathStepId,
  );
  const { header, description, stepCount, footer, buttonNext, buttonBack } =
    pathFinderMeshComponent.inputs.refs;
  const {
    backgroundColor,
    colorButton,
    colorButtonText,
    colorText,
    titleColorText,
    titleEnabled,
    stepEnabled,
  } = pathfinderDataState?.pathSettings || {};
  const { html, refs } = pathFinderMeshComponent.inputs;

  if (backgroundColor) html.style.backgroundColor = backgroundColor;
  if (colorButton) refs.buttonNext.style.backgroundColor = colorButton;
  if (colorButtonText) refs.buttonNext.style.color = colorButtonText;
  if (colorText) refs.description.style.color = colorText;

  if (titleEnabled) {
    header.innerHTML = pathfinderDataState.title;
    header.style.color = titleColorText || 'black';
    header.style.width = '600px';
  }

  if (stepEnabled && typeof stepIndex === 'number') {
    stepCount.innerHTML = `Step ${stepIndex + 1}/${game?.paths?.paths?.length}`;
    stepCount.style.color = colorText || 'black';
  }

  if (pathfinderDataState?.isEnablePreviousStep) {
    buttonBack.style.display = 'flex';
    footer.style.justifyContent = 'space-between';
  } else {
    buttonBack.style.display = 'none';
    footer.style.justifyContent = 'end';
  }

  buttonNext.innerHTML = pathfinderDataState.translation?.next || 'Next';
  description.innerHTML = pathfinderDataState.description;

  prevPathFinderData.description = pathfinderDataState.description;
  prevPathFinderData.isEnablePreviousStep = pathfinderDataState.isEnablePreviousStep;
};
